import React from 'react';
import Radio from 'rsuite/Radio';
import RadioGroup from 'rsuite/RadioGroup';
import OptionTitle from '../../OptionElements/OptionTitle';
import OptionDescription from '../../OptionElements/OptionDescription';
import OptionImage from '../../OptionElements/OptionImage';
import OptionPrice from '../../OptionElements/OptionPrice';
import { useRadioGroup } from '../hooks';
import * as Utils from 'utils';

export default function OptionTypeRadioEmailSignature(props) {
  const { options } = props;
  const [ optionId, onChangeOptionId ] = useRadioGroup(props);

  return (
    <RadioGroup
      className="app-option-list"
      value={optionId}
      onChange={onChangeOptionId}>
      {options.map((option) => {
        const {
          id,
          title,
          priceTitle,
          description,
          imageUrl,
          imageUrl2x,
          imageAlt,
          imageHeight,
          imageWidth,
          customClass,
          isDisabled = false
        } = option;

        return (
          <div className={`app-option-item ${customClass}`} key={id}>
            <Radio
              className="app-option-radio"
              value={id}
              disabled={isDisabled}>
              <div className="app-option-item-cards-content">
                <OptionTitle title={title} />
                <OptionDescription description={description} />
              </div>

              <div className="app-option-item-cards-image">
                <OptionImage
                    imageAlt={imageAlt}
                    imageUrl={imageUrl}
                    imageUrl2x={imageUrl2x}
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                />
                <OptionPrice
                    priceTitle={priceTitle}
                    priceValueText={Utils.replacer(option, 'priceValueText')}
                />
              </div>
            </Radio>
          </div>
        )
      })}
    </RadioGroup>
  )
};
